import styled from 'styled-components';

export const GoStreakReviewWrapper = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    border-radius: 0.8rem;
    margin-bottom: 0.8rem;
    overflow: hidden;
    ${!props.isMweb && 'cursor: pointer;'}
  `,
);

export const GoStreakDetailsHeaderWrapper = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    padding: 1.2rem 1.2rem 0.9rem;
    display: flex;
    align-items:center;
    justify-content: space-between;
    .headerText {
      display: flex;
      align-items:center;
      font-weight: 700;
      font-size: 1.2rem;
      line-height: 1.8rem;
      color: #FF554A;
    }
      `,
);

export const GoStreakDetailsContentWrapper = styled.div(
  props => `
    padding: 1.2rem;
    background: ${
      props.isMweb
        ? 'linear-gradient(135deg, #FFF6F3 0%, #FFFFFF 100%)'
        : 'linear-gradient(105.04deg, #FFEDE8 -82.15%, #FFFFFF 99.2%)'
    };
    .headerText  {
      font-weight: 700;
      font-size: ${props.isMweb ? '1.5rem' : '1.8rem'};
      line-height: ${props.isMweb ? '1.8rem' : '2.2rem'};
      color: #5B4D49;
      ${props.isMweb ? '' : 'margin-bottom: 0.8rem;'}
    }
    .descText {
      font-size: ${props.isMweb ? '1.2rem' : '1.4rem'};
      line-height: ${props.isMweb ? '1.4rem' : '1.8rem'};
      color: #5B4D49;
      ${props.isMweb ? '' : 'letter-spacing: 0.01em;'}      
    }
  `,
);

export const GoStreakDetailsContenInnerWrapper = styled.div(
  props => `
    display: flex;
    align-items:center;
    padding-top: 0.4rem;
    padding-bottom: 1.2rem;
    ${props.isMweb &&
      `
    .headerText  {
       margin-bottom:0.4rem;
    }
    `}

    ${!props.isMweb &&
      `.rightWrapper {
      align-self:baseline;
      margin-top: 4px;
    }`}
      `,
);
